<template>
  <div class="background">
  <div class="chart-container" id="container">
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('dailyReport')}}</p>
        <p style="font-size: 13px;">{{$t('date')}}:{{time}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt||isFr}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td>
        <td colspan="9" class="td4">{{statics.medical_history}}</td>
        <!--<td class="td td4">{{$t('HbA1c')}}</td>
        <td colspan="4">{{hb1c[0]}}</td>-->
      </tr>
    </table>

    <div class="small-hr"></div>
    <img id="img1_1" class="img">
    <img id="img1_2" class="img">
    <img id="img1_3" class="img">
    <div class="spe-hr"></div>

    <div class="legend-group" :class="{'de2':isDe,'it2':isIt||isFr,'po2':isPo,'es2':isEs,'du2':isDu||isCz,'sw2':isSw}">
      <div class="legend" :class="{'it3':isIt}"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
      <div class="legend" :class="{'it4':isIt}"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
      <div class="legend" :class="{'it5':isIt}"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"> <span>{{$t('hypo')}}</span></div>
      <div class="legend legend-spe15"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
      <div class="legend legend-spe16"><img src="../../assets/Hcp-icon/legend/calib.png"><span :class="{'span1':!isEn}" class="span1">{{$t('calib')}}</span></div>
      <div class="legend legend-spe17"><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
      <div class="legend legend-spe5" :class="{'zh3':!isEn}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
      <div class="legend legend-spe6" :class="{'zh4':!isEn,'du3':isDu}"><img src="../../assets/Hcp-icon/legend/temp basal.png"> <span>{{$t('tampBasal')}}</span></div>
      <div class="legend legend-spe12" :class="{'de5':isDe}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh5':!isEn,'de4':isDe}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
      <div class="legend legend-spe7" :class="{'zh6':!isEn}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
      <div class="legend" style="margin-right: 10px;"><img src="../../assets/Hcp-icon/legend/warm up.png"><span  :class="{'span1':!isEn}">{{$t('warm')}}</span></div>
      <div class="legend legend-spe3"  :class="{'zh2':!isEn}"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
      <div class="legend legend-spe4"  :class="{'zh18':!isEn}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
      <div class="legend legend-spe9" :class="{'zh7':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
      <div class="legend legend-spe2" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
      <div class="legend legend-spe10" :class="{'zh9':!isEn,'es3':isEs}"><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
      <div class="legend"  style="margin-right: 0"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span class="span1">{{$t('BG Reading')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/运动[30059].png"><span>{{$t('Exercise')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
      <div class="legend legend-spe11"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>

    </div>
    <div class="statics">
      <p>{{$t('statics')}}</p>
      <table class="statics-table" :class="{'de3':isDe}">
        <tr style="height: 5px;font-size:8px;line-height: 8px;" height="5px">
          <td width="18%"></td>
          <td></td>
          <td style="border-right:1px solid rgba(116,116,116,0.34);"></td>
          <td width="18%"></td>
          <td style="border-right:1px solid rgba(116,116,116,0.34);"></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="3"  class="td1" style="padding-bottom: 5px;">{{$t('glucose')}}</td>
          <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>
          <td rowspan="2" colspan="2" class="td2">{{$t('events')}}</td>
        </tr>
        <tr>
          <td class="td1"></td>
          <td  class="td1">{{$t('BG1')}}</td>
          <td  class="td1">{{$t('SG1')}}</td>
        </tr>
        <tr>
          <td  class="td1" style="width: 300px">{{$t('Avg')}}{{unit}}{{$t('±SD')}}</td>
          <td  class="td1">{{glucose.bg_avg_dev}}</td>
          <td  class="td1">{{glucose.sg_avg_dev}}</td>
          <td  class="td1"> {{$t('totalDose')}} {{$t('ins_unit')}}</td>
          <td  class="td1">{{insulin.total}}</td>
          <td  class="td1"> {{$t('carbs')}} (g)</td>
          <td class="td2">{{events.carb_total}}</td>
        </tr>
        <tr>
          <td  class="td1">{{$t('min')}}{{unit}}</td><td class="td1">{{glucose.bg_min}}</td><td class="td1">{{glucose.sg_min}}</td>
          <td  class="td1">{{$t('bolus')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.bolus}}</td>
          <td  class="td1"> {{$t('ofMeal')}}</td><td class="td2">{{events.meal_count}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('max')}}{{unit}}</td><td class="td1">{{glucose.bg_max}}</td><td class="td1">{{glucose.sg_max}}</td>
          <td class="td1">{{$t('basal')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.basal}}</td>
          <td  class="td1">{{$t('avgSD1')}}</td><td class="td2">{{events.meal_avg_sd}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('target')}} (%)</td><td class="td1">{{glucose.bg_np}}</td><td class="td1">{{glucose.sg_np}}</td>
          <td class="td1">{{$t('foodBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.carb_bolus}}</td>
          <td class="td1">{{$t('totalExerTime')}}</td><td class="td2">{{events.exercise_time}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('low1')}} (%)</td><td class="td1">{{glucose.bg_lp}}</td><td class="td1">{{glucose.sg_lp}}</td>
          <td class="td1">{{$t('calibBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.corr_bolus}}</td>
          <td class="td1">{{$t('exerNum')}}</td><td class="td2">{{events.exercise_count}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('high1')}} (%)</td><td class="td1">{{glucose.bg_hp}}</td><td class="td1">{{glucose.sg_hp}}</td>
          <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor}}</td>
          <td class="td1"> {{$t('avgInten')}}</td><td class="td2">{{events.exercise_avg_time}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('ofRead')}}</td><td class="td1">{{glucose.bg_rds_time}}</td><td class="td1">{{glucose.sg_data_num}}</td>
          <td class="td1"> {{$t('normalBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.normal_bolus}}</td>
          <td class="td1"></td><td class="td2"></td>
        </tr>
        <tr>
          <td class="td1">{{$t('ofHypo')}}</td><td class="td1">{{glucose.bg_hypo_rds_time}}</td><td class="td1">{{glucose.sg_hypo_num}}/{{glucose.sg_hypo_duration}}</td>
          <td class="td1">{{$t('extendBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.extent_bolus}}</td>
          <td class="td1"></td><td class="td2"></td>
        </tr>
        <tr>
          <td class="td1">{{$t('ofAlert')}}</td><td class="td1">{{glucose.bg_alarm_cnt}}</td><td class="td1">{{glucose.sg_alarm_cnt}}</td>
          <td class="td1">{{$t('tampBasal')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.temp_basal}}</td>
          <td class="td1"></td><td class="td2"></td>
        </tr>
        <tr>
          <td class="td1"></td><td class="td1"></td><td class="td1"></td>
          <td class="td1">{{$t('durationStop')}}</td><td class="td1">{{insulin.suspend_time}}</td>
          <td class="td1"></td><td class="td2"></td>
        </tr>
        <tr>
          <td class="td3"></td><td class="td3"></td><td class="td3"></td>
          <td class="td3">{{$t('ofPumpAlert')}}</td><td class="td3">{{insulin.pump_alarm_cnt}}</td>
          <td class="td3"></td><td></td>
        </tr>
      </table>

      <div class="statics">
        <!--        <p>{{$t('statics')}}</p>-->
        <table class="statics-table auto_mode" :class="{'de3':isDe}">
          <tr>
            <!--            <td colspan="3"  class="td1">{{$t('glucose')}}</td>-->
            <!--            <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>-->
            <td rowspan="1" colspan="2" class="td2" style="height: 30px">{{$t('t1222_Auto_Mode')}}</td>
          </tr>
          <!--          <tr>-->
          <!--            <td class="td1"></td><td  class="td1">{{$t('BG1')}}</td><td  class="td1">{{$t('SG1')}}</td>-->
          <!--          </tr>-->
          <tr>
            <!--            <td  class="td1">{{$t('Avg')}}{{unit}}{{$t('±SD')}}</td><td  class="td1">{{glucose.bg_avg_dev}}</td><td  class="td1">{{glucose.sg_avg_dev}}</td>-->
            <!--            <td  class="td1"> {{$t('totalDose')}} {{$t('ins_unit')}}</td><td  class="td1">{{insulin.total}}</td>-->
            <td  class="td1"> {{$t('t1222_Time_in_Auto_Mode')}}</td>
            <td class="td2">{{timeInAutoMode}}</td>
          </tr>

          <tr>
            <!--            <td  class="td1">{{$t('min')}}{{unit}}</td><td class="td1">{{glucose.bg_min}}</td><td class="td1">{{glucose.sg_min}}</td>-->
            <!--            <td  class="td1">{{$t('bolus')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.bolus}}</td>-->
            <td  class="td1"> {{$t('t1222_Avg_SD')}}</td>
            <td class="td2">{{autoModeSGAvgSD}} {{glucose_unit}}</td>
          </tr>
          <tr>
            <!--            <td class="td1">{{$t('max')}}{{unit}}</td><td class="td1">{{glucose.bg_max}}</td><td class="td1">{{glucose.sg_max}}</td>-->
            <!--            <td class="td1">{{$t('basal')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.basal}}</td>-->
            <td  class="td1">{{$t('t1222_Target_Range')}}</td>
            <td class="td2">{{autoModeSGInTargetRange}}</td>
          </tr>
          <tr>
            <!--            <td class="td1">{{$t('target')}} (%)</td><td class="td1">{{glucose.bg_np}}</td><td class="td1">{{glucose.sg_np}}</td>-->
            <!--            <td class="td1">{{$t('foodBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.carb_bolus}}</td>-->
            <td class="td1">{{$t('t1222_Above_Range')}}</td>
            <td class="td2">{{autoModeSGAboveRange}}</td>
          </tr>
          <tr>
            <!--            <td class="td1">{{$t('low1')}} (%)</td><td class="td1">{{glucose.bg_lp}}</td><td class="td1">{{glucose.sg_lp}}</td>-->
            <!--            <td class="td1">{{$t('calibBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.corr_bolus}}</td>-->
            <td class="td1">{{$t('t1222_Below_Range')}}</td>
            <td class="td2">{{autoModeSGBelowRange}}</td>
          </tr>
          <tr>
            <!--            <td class="td1">{{$t('high1')}} (%)</td><td class="td1">{{glucose.bg_hp}}</td><td class="td1">{{glucose.sg_hp}}</td>-->
            <!--            <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor}}</td>-->
            <td class=" td3"> {{$t('t1222_Auto_Mode_Exits')}}</td>
            <td class=" ">{{autoModeExits}}</td>
          </tr>


        </table>
      </div>

      <div class="page-end"></div>
    </div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
    import format from '@/lib/format'
  export default {
    data() {
      return {
        uid:0, et:0,st:0, time:'',isEn:false,foodCoor:'',unit:'',isMg:'',ts:[],isDe:false,isIt:false,isFr:false,isSw:false,isCz:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],glucose:[],insulin:[],events:[],isPo:false,isEs:false,isDu:false,

        // 自动模式
        timeInAutoMode:'--',
        autoModeSGAvgSD:'--',
        autoModeSGInTargetRange:'--',
        autoModeSGAboveRange:'--',
        autoModeSGBelowRange:'--',
        autoModeExits:0,

      }
    },
    methods: {
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ds',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices[0]:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
            this.glucose = (data.glucose_stat)?data.glucose_stat[0]:this.glucose;
           // console.log( this.glucose)
            this.insulin = (data.insulin_stat)?data.insulin_stat[0]:this.insulin;
            this.foodCoor =(this.insulin.carb_corr_bolus)?(this.insulin.carb_corr_bolus).toFixed(2):0;
            this.events =(data.event_stat)?data.event_stat[0]:this.events;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },

      getStatics2(report_data){
        let data=report_data;
        //let data =  res.data.data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices[0]:this.devices;
        this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
        this.glucose = (data.glucose_stat)?data.glucose_stat[0]:this.glucose;
        // console.log( this.glucose)
        this.insulin = (data.insulin_stat)?data.insulin_stat[0]:this.insulin;
        this.foodCoor =(this.insulin.carb_corr_bolus)?(this.insulin.carb_corr_bolus).toFixed(2):0;
        this.events =(data.event_stat)?data.event_stat[0]:this.events;
        // 自动模式统计项
        this.timeInAutoMode = report_data.timeInAutoMode;
        this.autoModeSGAvgSD = report_data.autoModeSGAvgSD;
        this.autoModeSGInTargetRange = report_data.autoModeSGInTargetRange;
        this.autoModeSGAboveRange = report_data.autoModeSGAboveRange;
        this.autoModeSGBelowRange = report_data.autoModeSGBelowRange;
        this.autoModeExits = report_data.autoModeExits;
      },

      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('dailyReport');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.unit = (this.isMg)?' (mg/dL)':' (mmol/L)';
      this.glucose_unit = this.unit;
      let st = sessionStorage.getItem('st');
      this.st = parseInt(st);
      this.et = this.st+86400;
      this.time =format.formatterDate2(this.st);
      this.ts = [[this.st,this.et]];
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      //this.getStatics(param);
      let report_data=sessionStorage.getItem('ds_report_data')
      report_data=JSON.parse(report_data)
      //console.log('report_data:', report_data)
      this.getStatics2(report_data);

      let img1 = document.getElementById('img1_1');
      img1.src = sessionStorage.getItem('src1_1');
      let img2 = document.getElementById('img1_2');
      img2.src = sessionStorage.getItem('src1_2');
      let img3 = document.getElementById('img1_3');
      img3.src = sessionStorage.getItem('src1_3');
      setTimeout(auth._printPdf(),2000);
    },
  }
</script>
<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 2mm;
    width: 100%;
    *height: 297mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height:297mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .spe-hr{
    width:94%;
    border-top:1px solid #e6e8ea;
    margin:10px auto 10px;
  }
  .img{
    width:97%;
    *height:140px;
    height:30mm;
    margin-left: 2%;
    margin-bottom: 5px;
  }

  .legend-group{
    width:97%;
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:60px;
    height:20px;
    line-height: 20px;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 40px;
  }
  .legend-spe2{
    margin-bottom: 1px;
    margin-right: 90px;
  }
  .legend-spe3{
    margin-right: 30px;
  }
  .legend-spe4{
    margin-right: 35px;
  }
  .legend-spe5{
    margin-right:44px;
  }
  .legend-spe6{
    margin-right:40px;
  }
  .legend-spe7{
    margin-right: 30px;
  }
  .legend-spe8{
    margin-right: 70px;
  }
  .legend-spe9{
    margin-right: 58px;
  }
  .legend-spe10{
    margin-right: 88px;
  }
  .legend-spe11{
    margin-right: 40px;
  }
  .legend-spe12{
    margin-right:35px;
  }
  .legend-spe15{
    margin-right: 48px;
  }
  .legend-spe16{
    margin-right: 65px;
  }
  .legend-spe17{
    margin-right:0;
  }
  .zh2{
    margin-right: 50px;
  }
  .zh18{
    margin-right: 71px;
  }
  .zh3{
    margin-right: 40px;
  }
  .zh4{
    margin-right: 52px;
  }
  .zh5{
    margin-right: 32px;
  }
  .zh6{
    margin-right: 36px;
  }
  .zh7{
    margin-right: 56px;
  }
  .zh8{
    margin-right: 82px;
  }
  .zh9{
    margin-right: 65px;
  }
  .legend-group .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .de2 .legend{
    margin-right: 30px;
  }
  .de2 .de4{
    margin-right: 20px;
  }
  .de2 .de5{
    margin-right: 15px;
  }

  .it2 .legend{
    margin-right: 32px;
  }
  .it2 .it3{
    margin-right: 46px;
  }
  .it2 .it4{
    margin-right: 50px;
  }
  .it2 .it5{
    margin-right: 60px;
  }
  .it2 .legend-spe15{
    margin-right: 48px;
  }
  .it2  .legend-spe16{
    margin-right: 65px;
  }
  .it2 .legend-spe17{
    margin-right:0;
  }
  .po2 .legend{
    margin-right: 22px;
  }
  .es2 .legend{
    margin-right: 32px;
  }
  .es2 .legend-spe15{
    margin-right: 48px;
  }
  .es2  .legend-spe16{
    margin-right: 65px;
  }
  .es2 .legend-spe17{
    margin-right:0;
  }
  .es2 .es3{
    margin-right: 72px;
  }
  .es2 .legend-spe6{
    margin-right: 15px;
  }
  .es2 .legend-spe7{
    margin-right: 15px;
  }

  .du2 .legend{
    margin-right: 32px;
  }
  .du2 .legend-spe15{
    margin-right: 28px;
  }
  .du2  .legend-spe16{
    margin-right: 25px;
  }
  .du2 .legend-spe17{
    margin-right:28px;
  }
  .du2 .du3{
    margin-right:45px;
  }

  .sw2 .legend-spe5{
    margin-right: 60px;
  }
  .sw2 .legend-spe1{
    margin-right: 30px;
  }
  .sw2 .legend-spe7{
    margin-right: 20px;
  }
  .sw2 .legend-spe3{
    margin-right: 35px;
  }
  .sw2 .legend-spe4{
    margin-right: 20px;
  }
  .sw2 .legend-spe9{
    margin-right: 40px;
  }
  .sw2 .legend-spe2{
    margin-right: 88px;
  }
  .sw2 .legend-spe10{
    margin-right: 55px;
  }
  .sw2 .legend-spe16{
    margin-right:58px;
  }

  .statics{
    clear: both;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table.auto_mode {
    width: 50%;
    margin-left:3%;
  }
  .de3{
    word-break: break-all;
    word-wrap: break-word;
  }
  .statics-table td{
    height:15px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .page-end {
    clear: both;
    height:2mm;
  }
</style>



// WEBPACK FOOTER //
// chart1_print.vue?c41dfef6